import { PRE_CHECK_MACHINE_STATES } from './constants'

export default function studentPreCheckFlow(studentPreChecksState){

    const { currentCheck, settings } = studentPreChecksState

    const requiresAudioChecks = settings.shouldDoAudioChecks
    const requiresFirstTimeIntroduction = settings.shouldGoThroughFTUE
    const asrOnlyMode = settings.asrOnlyMode
    const requiresIntroVideo = settings.shouldShowIntroVideo

    function getNextPreCheckItem(){

        // ASR_ONLY mode: skip all checks and go straight to ASR
        if(asrOnlyMode && currentCheck === PRE_CHECK_MACHINE_STATES.init) return PRE_CHECK_MACHINE_STATES.studentASRChecks
        if(asrOnlyMode && currentCheck === PRE_CHECK_MACHINE_STATES.studentASRChecks) return PRE_CHECK_MACHINE_STATES.end

        // TT-935: the intro video plays first, before any of the checks begin.
        // ASR_ONLY mode is handled above, so it never reaches the video.
        if(requiresIntroVideo && currentCheck === PRE_CHECK_MACHINE_STATES.init) return PRE_CHECK_MACHINE_STATES.introVideo
        if(currentCheck === PRE_CHECK_MACHINE_STATES.introVideo) return PRE_CHECK_MACHINE_STATES.networkSpeedChecks

        // these checks will always run (unless in ASR_ONLY mode)
        if(currentCheck === PRE_CHECK_MACHINE_STATES.init) return PRE_CHECK_MACHINE_STATES.networkSpeedChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.networkSpeedChecks) return PRE_CHECK_MACHINE_STATES.networkPingChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.networkPingChecks) return PRE_CHECK_MACHINE_STATES.hardwareChecks
        // jump straight to ready to end checks
        if(!requiresAudioChecks && !requiresFirstTimeIntroduction && currentCheck === PRE_CHECK_MACHINE_STATES.hardwareChecks) return PRE_CHECK_MACHINE_STATES.end
        if(currentCheck === PRE_CHECK_MACHINE_STATES.hardwareChecks) return PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks) return PRE_CHECK_MACHINE_STATES.studentASRChecks
        if(currentCheck === PRE_CHECK_MACHINE_STATES.studentASRChecks) return PRE_CHECK_MACHINE_STATES.end

        return PRE_CHECK_MACHINE_STATES.init
    }

    function getCurrentCheckItem(){
        return currentCheck
    }

    return {
        getNextPreCheckItem,
        getCurrentCheckItem
    }
}